export default __webpack_public_path__ + "static/media/B0007.eef335f7.png";